/**
 * Get the sum total of tonnage with the safety factor for a given application.
 */
import { createSelector } from 'reselect';

import getApplicationSelector from '/business/shared/state/selectors/application/getApplicationSelector';

export default createSelector([getApplicationSelector], (application = null) => {
  return application?.emissions?.carbonTonnesWithSafetyFactor || 0;
});
